import emoji from 'react-easy-emoji'

export const truncateText = (text = '', limit = 0) => {
  if (text && text?.length > limit) {
    return text.substring(0, limit) + '...'
  }
  return text
}

export const convertHtmlToPlainText = (html) => {
  var tempDivElement = document.createElement('div')

  tempDivElement.innerHTML = html

  // Retrieve the text property of the element
  return tempDivElement.textContent || tempDivElement.innerText || ''
}

export const fixNumbers = (str) => {
  let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    englishNumbers = [/٠/g, /1/g, /2/g, /3/g, /4/g, /5/g, /6/g, /7/g, /8/g, /9/g]
  if (typeof str === 'string') {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(englishNumbers[i], i)
    }
  }
  return str
}

// checks for type and returns emoji symbol
export const getEmoji = (symbol) => {
  if (typeof symbol === 'string') {
    return emoji(symbol)
  }

  return ''
}
